<template>
    <div class="navigation-about">
        <div class="navigation__loader" v-if="loading || error">
                <LoadingIndicator/>
        </div>
        <div class="navigation-about__primary"  v-if="!loading && !error">
           <div class="navigation-about__primary-title">{{ content.dropdownTitle }}</div>
           <div class="navigation-about__primary-actions">
               <a class="navigation-about__primary-action" :href="action.url" :target="action.target" v-for="action in content.primaryActions" :key="action.name">
                {{ action.name }}
               </a>
           </div>
        </div>
        <div class="navigation-about__secondary"  v-if="!loading && !error">
            <div class="navigation-about__secondary-actions">
                <a class="navigation-about__secondary-action" :href="action.url" :target="action.target" v-for="action in content.secondaryActions" :key="action.name">
                {{ action.name }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
    components: {
        LoadingIndicator
    },
    data() {
        return {
            error: false,
            loading: true,
            content: [],
        }
    },
    mounted() {
        this.getContent();
    },
  
    methods: {
     
        getContent: function () {
            axios.post("/api/our-firm?culture=" + document.documentElement.lang , null, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => { 
                    this.content = response.data
                    this.loading = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                 });
        }
    }
}
</script>

